// English source strings of the content language (decision D37.3): Settings › General, the project override and the
// Kanban "Translate tasks" action. Merged into `en`; pt-BR lives in pt-BR-content.ts.
export const enContent = {
  "settings.tab.general": "General",
  "contentLanguage.title": "Content language",
  "contentLanguage.body":
    "The language the agents write what people read in: task titles, descriptions and acceptance criteria, review findings, summaries and explanations. Code, identifiers, file names and commit messages are never translated.",
  "contentLanguage.label": "Language of the content",
  "contentLanguage.hint": "Applies to new text. Existing tasks can be translated from a project's Kanban.",
  "contentLanguage.adminOnly": "Only organization administrators can change it.",
  "contentLanguage.saved": "Content language saved",
  "contentLanguage.projectLabel": "Content language",
  "contentLanguage.projectHint": "The language the agents write this project's tasks and reviews in.",
  "contentLanguage.inherit": "Same as the organization",

  "translateTasks.button": "Translate tasks",
  "translateTasks.running": "Translating…",
  "translateTasks.confirmTitle": "Translate the tasks into {language}?",
  "translateTasks.confirmBody":
    "{count} task(s) not started yet will have their title, description and acceptance criteria rewritten in {language} by the planner's model. Spending is capped at {cap}.",
  "translateTasks.kept": "Requirement ids, links, file names and code are kept as they are. Tasks already started are not touched.",
  "translateTasks.confirm": "Translate",
  "translateTasks.paidTitle": "The planner's model is paid",
  "translateTasks.paidBody": "Translating {count} task(s) with {model} may cost up to {cap}. Confirm to spend it.",
  "translateTasks.confirmPaid": "Confirm and translate",
  "translateTasks.done": "{translated} task(s) translated, {skipped} skipped",
  "translateTasks.failed": "The translation failed",
};
